import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaBookOpen, FaGraduationCap } from 'react-icons/fa';
import './UniversityHome.css'; // Reuse existing styles for consistency

const mockCourses = [
  {
    id: 1,
    title: 'Introduction to Computer Science',
    description: 'Learn the basics of computer science, programming, and algorithms.',
    duration: '12 weeks',
    level: 'Beginner',
  },
  {
    id: 2,
    title: 'Business Management Fundamentals',
    description: 'Explore the core principles of business administration and management.',
    duration: '10 weeks',
    level: 'Intermediate',
  },
  {
    id: 3,
    title: 'Modern Engineering Practices',
    description: 'A comprehensive overview of engineering disciplines and practices.',
    duration: '14 weeks',
    level: 'Advanced',
  },
  {
    id: 4,
    title: 'Creative Arts & Humanities',
    description: 'Dive into creative writing, philosophy, and the arts.',
    duration: '8 weeks',
    level: 'All Levels',
  },
];

const UniversityCourses = () => {
  const navigate = useNavigate();

  return (
    <div className="university-home">
      <header className="university-header">
        <div className="university-header-content">
          <button className="btn-secondary" onClick={() => navigate('/university-home')} style={{marginRight: 16}}>
            <FaArrowLeft /> Back
          </button>
          <h1 style={{margin: 0}}>University Courses</h1>
        </div>
      </header>
      <main className="university-main">
        <div className="university-main-container">
          <section className="university-programs-section">
            <div className="university-section-header">
              <h3>Available Courses</h3>
              <p>Browse and discover courses offered by the university</p>
            </div>
            <div className="university-programs-grid">
              {mockCourses.map(course => (
                <div key={course.id} className="university-program-card">
                  <div className="university-program-image" style={{background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', height: 120}}>
                    <FaBookOpen size={48} color="#4a90e2" />
                  </div>
                  <div className="university-program-content">
                    <h4>{course.title}</h4>
                    <p>{course.description}</p>
                    <div className="university-program-meta">
                      <span><FaGraduationCap /> {course.level}</span>
                      <span style={{marginLeft: 12}}>{course.duration}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default UniversityCourses; 